import CustomSegment from "../../../../components/ui/CustomSegment";
import { useSegment } from "../../../../hooks/useSegment";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { SegmentedType } from "../../../../types";
import LeaveAllocation from "./_components/LeaveAllocation";
import LeaveRequests from "./_components/LeaveRequests";

type SegmentType = "requests" | "allocation";

export default function LeaveManagement() {
  const { segment, setSegment } = useSegment<SegmentType>(
    "leave-segment",
    "requests"
  );

  const SEGMENT_CONFIG: SegmentedType<SegmentType>[] = [
    {
      key: "requests",
      label: "Leave Requests",
      element: <LeaveRequests />,
    },
    {
      key: "allocation",
      label: "Leave Allocation",
      element: <LeaveAllocation />,
    },
  ];
  const currentSegment = SEGMENT_CONFIG.find((s) => s.key === segment);

  return (
    <SidebarLayout title="Leaves">
      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.element}</div>
    </SidebarLayout>
  );
}
